const home = {
  'hero.eyebrow': 'The USFans Resource Hub',
  'hero.title': 'USFans Spreadsheet — Find Products, Sellers & Buying Resources Faster',
  'hero.subtitle': 'Explore USFans spreadsheet resources, product lists, seller information, reviews, shipping guides and practical buying resources in one organized place.',
  'hero.primaryCta': 'USFans Spreadsheet',
  'hero.secondaryCta': 'Buy It Now',
  'hero.trust': 'Independent Resource • Updated Regularly • Built for Easier Product Research',

  'category.browse': 'Browse Categories',
  'category.label': 'Choose a Category',
  'category.all': 'All Categories',
  'category.hint': 'Jump straight to a product category on the main website.',

  'categories.shoes': 'Shoes',
  'categories.hoodies': 'Hoodies / Sweaters',
  'categories.tshirts': 'T-Shirts',
  'categories.jackets': 'Jackets',
  'categories.pants': 'Pants / Shorts',
  'categories.headwear': 'Headwear',
  'categories.sets': 'Sets',
  'categories.underwear': 'Underwear / Underpants',
  'categories.jersey': 'Jersey',
  'categories.accessories': 'Accessories',
  'categories.bags': 'Bags',
  'categories.belts': 'Belts',
  'categories.perfumes': 'Perfumes',
  'categories.other': 'Other Stuff',

  'whatis.title': 'What Is a USFans Spreadsheet?',
  'whatis.copy': 'A USFans spreadsheet can help organize product information, seller resources and useful buying references in one place. Our goal is to make product research easier by organizing relevant USFans resources into searchable categories, guides and comparisons.',
  'whatis.cta': 'Explore the Spreadsheet Hub',

  'why.title': 'Everything You Need for Smarter USFans Research',
  'why.subtitle': 'Organized resources designed to help you research products and sellers with more confidence.',
  'why.card1.title': 'USFans Spreadsheet',
  'why.card1.desc': 'Find organized product and seller resources in one searchable place.',
  'why.card2.title': 'Seller Directory',
  'why.card2.desc': 'Explore seller-related information and research guides.',
  'why.card3.title': 'Product Guides',
  'why.card3.desc': 'Discover category-specific research tips for smarter decisions.',
  'why.card4.title': 'USFans Reviews',
  'why.card4.desc': 'Understand important factors before using a service or resource.',
  'why.card5.title': 'Shipping Guides',
  'why.card5.desc': 'Learn about shipping costs, methods and common considerations.',
  'why.card6.title': 'Safety Center',
  'why.card6.desc': 'Learn how to identify suspicious links, offers and common risks.',

  'popular.title': 'Popular USFans Searches',
  'popular.subtitle': 'Explore the topics people search for most when researching USFans resources.',
  'popular.1': 'USFans Review',
  'popular.2': 'USFans Shipping Cost',
  'popular.3': 'USFans Coupon',
  'popular.4': 'USFans Discount Code',
  'popular.5': 'USFans Warehouse',
  'popular.6': 'Is USFans Legit?',
  'popular.7': 'USFans Spreadsheet',
  'popular.8': 'USFans Seller Guide',

  'compare.title': 'Compare USFans Resources Before You Decide',
  'compare.subtitle': 'A quick reference to understand what each resource helps with. We never invent ratings, prices or verification claims.',
  'compare.col.resource': 'Resource',
  'compare.col.category': 'Category',
  'compare.col.info': 'What It Helps With',
  'compare.row1.resource': 'USFans Spreadsheet',
  'compare.row1.category': 'Research',
  'compare.row1.info': 'Product and seller information organization',
  'compare.row2.resource': 'Seller Directory',
  'compare.row2.category': 'Sellers',
  'compare.row2.info': 'Seller-related research and verification guidance',
  'compare.row3.resource': 'Product Guides',
  'compare.row3.category': 'Products',
  'compare.row3.info': 'Category-specific product research tips',
  'compare.row4.resource': 'Shipping Guides',
  'compare.row4.category': 'Shipping',
  'compare.row4.info': 'Shipping methods, costs and considerations',
  'compare.row5.resource': 'Safety Center',
  'compare.row5.category': 'Safety',
  'compare.row5.info': 'Risk awareness and safe browsing practices',

  'article.faqTitle': 'Frequently Asked Questions',
  'guides.title': 'USFans Guides & Tutorials',
  'guides.subtitle': 'Original, in-depth guides to help you research products and sellers more effectively.',
  'guides.updated': 'Updated',
  'guides.minRead': 'min read',
  'guides.category.guide': 'Guide',
  'guides.category.review': 'Review',
  'guides.category.shipping': 'Shipping',

  'safety.title': 'Stay Safer When Researching USFans Resources',
  'safety.copy': 'Always verify websites, sellers, links, payment information and product details independently. Our Safety Center explains common risks including suspicious websites, phishing links, misleading promotions and unsafe browsing practices.',
  'safety.cta': 'Visit Safety Center',
  'safety.point1': 'Verify websites and links independently',
  'safety.point2': 'Never share payment or account details carelessly',
  'safety.point3': 'Watch out for misleading promotions and fake offers',
  'safety.point4': 'Research sellers before making a decision',

  'final.title': 'Ready to Explore the USFans Spreadsheet?',
  'final.copy': 'Start with the USFans Spreadsheet Hub, compare useful resources and explore practical guides designed to make your research faster and easier.',
  'final.cta': 'Explore USFans Spreadsheet',
  'final.secondary': 'Visit Main Website',
};

export default home;